module.exports = __webpack_public_path__ + "static/cambium-footer-banner-desktop-1a1f983f296c12eaf6089c2c1685c6b5.svg";